import React from 'react';
import { LineItem } from '../elements-forms/line-item';
import {
  PrepareDiscountFields,
  RevisedCalculator,
  TableLabel
} from '../elements-forms/line-item-helpers';
import { TooltipData } from '../elements-tooltip/tooltip';

export const DayRateDiscountDisplay = ({ bookingObj }) => {
  const { listing, discounts } = bookingObj;
  // for subtotal
  const price = _.get(listing, 'prices[0]');
  const currencyType = _.get(price, 'currency');
  // discounts/charges are an array, but we cant relay on order. if 8 hour discount
  // is the first one, and on update its lost (say 7 hour booking), then the
  // order is useless. So made an object with types as keys
  return (
    <RevisedCalculator>
      <TableLabel
        firstCaption={{
          value: '',
          optionalClass: 'table-label'
        }}
        secondCaption={{
          value: '',
          optionalClass: 'right-data table-label'
        }}
      />
      {discounts.map((discount, i) => {
        if ('DAY_RATE_DISCOUNT' !== discount.type) {
          return null;
        }
        const currentDiscount = PrepareDiscountFields(discount);
        return (
          <LineItem
            key={`day-rate-discount-${i}`}
            label={{ content: currentDiscount.content }}
            value={{
              amount: parseFloat(`-${currentDiscount.value}`).toFixed(2)
            }}
            optionalValue={{
              amount: '0',
              optionalClass: 'no-discount',
              optionalTooltip: TooltipData.HOST_UPDATE_EIGHT_HOUR_DISCOUNT_LOSS
            }}
            currencyType={currencyType}
          />
        );
      })}
    </RevisedCalculator>
  );
};
